import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeDataChangeRequest  {
    _originalTypeClassName = "zSHR.BO.EmployeeDataChangeRequest";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeDataChangeRequest.translate = translateService;
}
this.Id = null;
this.Email = null;
this.Status = null;
this.DateRequested = null;
this.DateCompleted = null;
this.PhoneNumber = null;
this.DocumentId = null;
this.PassportId = null;
this.IBAN = null;
this.TaxNumber = null;
this.DocumentIssueDate = null;
this.DocumentExpirationDate = null;
this.DocumentAuthority = null;
this.FirstName = null;
this.LastName = null;
this.MotherName = null;
this.MotherSurname = null;
this.FatherName = null;
this.FatherSurname = null;
this.DateOfBirth = null;
this.PlaceOfBirth = null;
this.SpouseName = null;
this.ChildrenCount = null;
this.Gender = null;
this.FamilyStatus = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Email:any;
Status:any;
DateRequested:any;
DateCompleted:any;
PhoneNumber:any;
DocumentId:any;
PassportId:any;
IBAN:any;
TaxNumber:any;
DocumentIssueDate:any;
DocumentExpirationDate:any;
DocumentAuthority:any;
FirstName:any;
LastName:any;
MotherName:any;
MotherSurname:any;
FatherName:any;
FatherSurname:any;
DateOfBirth:any;
PlaceOfBirth:any;
SpouseName:any;
ChildrenCount:any;
Gender:any;
FamilyStatus:any;
Address:any;
Employee:any;
Citizenship:any;
Nationality:any;
static setAddress = ($this, value) => {
var oldValue = $this.Address;
$this.Address = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setCitizenship = ($this, value) => {
var oldValue = $this.Citizenship;
$this.Citizenship = value;
if (value != null) {
}
}
static setNationality = ($this, value) => {
var oldValue = $this.Nationality;
$this.Nationality = value;
if (value != null) {
}
}

static DomainFamilyStatusToInterface(familyStatus: any): any{switch (familyStatus) {case Domain.FamilyStatus.Single:
{
return 0 /* Interfaces.EmployeeAPI.FamilyStatus.Single */;}
case Domain.FamilyStatus.Married:
{
return 1 /* Interfaces.EmployeeAPI.FamilyStatus.Married */;}
case Domain.FamilyStatus.Widowed:
{
return 3 /* Interfaces.EmployeeAPI.FamilyStatus.Widowed */;}
case Domain.FamilyStatus.Divorced:
{
return 2 /* Interfaces.EmployeeAPI.FamilyStatus.Divorced */;}
default:
{
return 0 /* Interfaces.EmployeeAPI.FamilyStatus.Single */;}
}
}
static DomainGenderToInterface(gender: any): any{switch (gender) {case Domain.Gender.Female:
{
return 1 /* Interfaces.EmployeeAPI.Gender.Female */;}
case Domain.Gender.Male:
{
return 0 /* Interfaces.EmployeeAPI.Gender.Male */;}
default:
{
return 1 /* Interfaces.EmployeeAPI.Gender.Female */;}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}